import { createVuetify } from 'vuetify'
import { theme_dark, theme_light } from '~/themes/themes'

export default defineNuxtPlugin((nuxtApp) => {
   const vuetify = createVuetify({
      components: {},
      defaults: {
         global: {
            ripple: true
         },
         VAppBar: {
            style: 'background: rgb(var(--v-theme-surfaceDark)) !important;'
         },
         VBtn: {
            class: 'text-body-1',
            rounded: 'lg'
         },
         VCard: {
            density: 'compact',
            elevation: 0,
            style: 'background: rgb(var(--v-theme-surfaceLight));',
            tag: 'article',
            VImg: {
               style: 'box-shadow: 2px 4px 8px rgb(var(--v-theme-surfaceDark));'
            }
         },
         VCardActions: {
            VBtn: {
               class: 'text-body-1 rounded-pill',
               density: 'compact'
            }
         },
         VCardText: {
            class: 'pa-3 text-body-1',
            style: 'background: rgb(var(--v-theme-surfaceEdgeTop));',
            tag: 'section'
         },
         VCardTitle: {
            class: "align-center d-flex",
            style: 'font-weight: bold;',
            tag: 'h3'
         },
         VCheckbox: {
            color: 'secondary'
         },
         VCombobox: {
            class: 'py-2',
            color: 'secondary',
            density: 'compact',
            variant: 'underlined',
            validateOn: 'blur'
         },
         VContainer: {
            class: 'pa-0'
         },
         VDataTableServer: {
            fixedHeader: true,
            noDataText: 'no data available'
         },
         VDivider: {
            class: 'border-opacity-25'
         },
         VFooter: {
            elevation: 8,
            style: 'border-top: 1px solid rgb(var(--v-theme-surfaceLight))'
         },
         VNavigationDrawer: {
            elevation: 4
         },
         VRadioGroup: {
            color: 'secondary'
         },
         VSelect: {
            class: 'py-2',
            color: 'secondary',
            density: 'compact',
            variant: 'underlined',
            validateOn: 'blur'
         },
         VSheet: {
            border: true
         },
         VTab: {
            VBtn: {
               class: 'ma-0 px-3 rounded-0 text-caption',
               style: 'width: 25vw'
            }
         },
         VTextarea: {
            density: 'compact',
            variant: 'underlined'
         },
         VTextField: {
            class: 'py-2',
            color: 'secondary',
            density: 'compact',
            hideDetails: 'auto',
            variant: 'underlined',
            validateOn: 'blur'
         },
         VToolbar: {
            color: 'surface',
            density: 'compact',
            VBtn: {
               class: 'mr-2',
               style: 'background: rgba(var(--v-theme-surfaceLight), 0.6); height: calc(var(--v-btn-height) - 8px);'
            }
         },
         VToolbarTitle: {
            class: 'mx-0'
         },
         VTooltip: {
            location: 'top'
         }
      },
      display: {
         mobileBreakpoint: 'md',
      },
      theme: {
         defaultTheme: 'theme_light',
         variations: {
            colors: ['primary', 'secondary', 'surfaceDark'],
            lighten: 3,
            darken: 3
         },
         themes: {
            theme_dark,
            theme_light
         }
      }
   })

   nuxtApp.vueApp.use(vuetify)
})
